'use strict';

var blzTrackingUtil = {
  calculateAge: function (birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  },

  guid: function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },

  setCookie: function (cookieName, cookieValue, time) {
    var date = new Date();
    date.setTime(date.getTime() + (time || 30 * 60 * 1000));
    var secure = document.location.port ? '' : 'secure';

    return (
      cookieName +
      '=' +
      cookieValue +
      '; expires=' +
      date.toGMTString() +
      '; domain=' +
      blz.rootDomain +
      '; path=/' +
      '; ' +
      secure
    );
  },

  readCookie: function (cookieName) {
    var er = new RegExp(cookieName + '=([^;]+)');
    var match = document.cookie.match(er);
    return match ? match[1] : null;
  }
};

module.exports = blzTrackingUtil;
